// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as GraphqlTag from "graphql-tag";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as Trophy$LiteracyplanetClientSxEntry from "../Trophy.res.mjs";
import * as QueryHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/QueryHook2.res.mjs";
import * as LocaleContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/LocaleContext.res.mjs";
import * as AcademyFragments$LiteracyplanetClientSxEntry from "./AcademyFragments.res.mjs";
import * as YearLevelMappingQuery$LiteracyplanetClientSxEntry from "./YearLevelMappingQuery.res.mjs";

var Raw = {};

var query = GraphqlTag.gql([
      "query AcademyIndexQuery($yearLevel: LearningLevelEnum!, $locale: Locale!, $md5: String!)  {\nfindDefaultMenuNodesByLevel(level: $yearLevel, locale: $locale, md5: $md5)  {\n...MenuFragment   \n}\n\nfindStrandsByLevel(level: $yearLevel, locale: $locale, md5: $md5)  {\n...MenuFragment   \n}\n\n}\n",
      ""
    ], AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.query);

function parse(value) {
  var value$1 = value.findDefaultMenuNodesByLevel;
  var value$2 = value.findStrandsByLevel;
  return {
          findDefaultMenuNodesByLevel: value$1.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.verifyArgsAndParse("MenuFragment", value);
              }),
          findStrandsByLevel: value$2.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.verifyArgsAndParse("MenuFragment", value);
              })
        };
}

function serialize(value) {
  var value$1 = value.findStrandsByLevel;
  var findStrandsByLevel = value$1.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.serialize(value);
      });
  var value$2 = value.findDefaultMenuNodesByLevel;
  var findDefaultMenuNodesByLevel = value$2.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.serialize(value);
      });
  return {
          findDefaultMenuNodesByLevel: findDefaultMenuNodesByLevel,
          findStrandsByLevel: findStrandsByLevel
        };
}

function serializeVariables(inp) {
  var a = inp.yearLevel;
  var a$1 = inp.locale;
  return {
          yearLevel: a === "LEVEL_10" ? "LEVEL_10" : (
              a === "LEVEL_11" ? "LEVEL_11" : (
                  a === "LEVEL_12" ? "LEVEL_12" : (
                      a === "PRE" ? "PRE" : (
                          a === "LEVEL_0" ? "LEVEL_0" : (
                              a === "LEVEL_1" ? "LEVEL_1" : (
                                  a === "LEVEL_2" ? "LEVEL_2" : (
                                      a === "LEVEL_3" ? "LEVEL_3" : (
                                          a === "LEVEL_4" ? "LEVEL_4" : (
                                              a === "LEVEL_5" ? "LEVEL_5" : (
                                                  a === "LEVEL_6" ? "LEVEL_6" : (
                                                      a === "LEVEL_7" ? "LEVEL_7" : (
                                                          a === "LEVEL_8" ? "LEVEL_8" : (
                                                              a === "LEVEL_9" ? "LEVEL_9" : "UNKNOWN"
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          locale: a$1 === "en_BZ" ? "en_BZ" : (
              a$1 === "en_CA" ? "en_CA" : (
                  a$1 === "en_CB" ? "en_CB" : (
                      a$1 === "en_GB" ? "en_GB" : (
                          a$1 === "en_IE" ? "en_IE" : (
                              a$1 === "en_IN" ? "en_IN" : (
                                  a$1 === "en_JM" ? "en_JM" : (
                                      a$1 === "en_NZ" ? "en_NZ" : (
                                          a$1 === "en_PH" ? "en_PH" : (
                                              a$1 === "en_TT" ? "en_TT" : (
                                                  a$1 === "en_US" ? "en_US" : (
                                                      a$1 === "en_ZA" ? "en_ZA" : (
                                                          a$1 === "en_ZW" ? "en_ZW" : "en_AU"
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          md5: inp.md5
        };
}

function makeVariables(yearLevel, locale, md5, param) {
  return {
          yearLevel: yearLevel,
          locale: locale,
          md5: md5
        };
}

var IndexQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useFetch = include.useFetch;

var IndexQuery = {
  IndexQuery_inner: IndexQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useFetch: useFetch
};

var IQ = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useFetch: useFetch
    });

var Raw$1 = {};

var query$1 = GraphqlTag.gql([
      "query AcademyMenuQuery($id: ID!, $yearLevel: LearningLevelEnum!, $locale: Locale!, $md5: String!)  {\nfindMenuNodesByParentId(id: $id, locale: $locale, md5: $md5)  {\n...MenuFragment   \n}\n\nfindBreadCrumb(id: $id, locale: $locale, md5: $md5)  {\n...MenuFragment   \n}\n\nfindStrandsByLevel(level: $yearLevel, locale: $locale, md5: $md5)  {\n...MenuFragment   \n}\n\n}\n",
      ""
    ], AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.query);

function parse$1(value) {
  var value$1 = value.findMenuNodesByParentId;
  var value$2 = value.findBreadCrumb;
  var value$3 = value.findStrandsByLevel;
  return {
          findMenuNodesByParentId: value$1.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.verifyArgsAndParse("MenuFragment", value);
              }),
          findBreadCrumb: value$2.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.verifyArgsAndParse("MenuFragment", value);
              }),
          findStrandsByLevel: value$3.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.verifyArgsAndParse("MenuFragment", value);
              })
        };
}

function serialize$1(value) {
  var value$1 = value.findStrandsByLevel;
  var findStrandsByLevel = value$1.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.serialize(value);
      });
  var value$2 = value.findBreadCrumb;
  var findBreadCrumb = value$2.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.serialize(value);
      });
  var value$3 = value.findMenuNodesByParentId;
  var findMenuNodesByParentId = value$3.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.serialize(value);
      });
  return {
          findMenuNodesByParentId: findMenuNodesByParentId,
          findBreadCrumb: findBreadCrumb,
          findStrandsByLevel: findStrandsByLevel
        };
}

function serializeVariables$1(inp) {
  var a = inp.yearLevel;
  var a$1 = inp.locale;
  return {
          id: inp.id,
          yearLevel: a === "LEVEL_10" ? "LEVEL_10" : (
              a === "LEVEL_11" ? "LEVEL_11" : (
                  a === "LEVEL_12" ? "LEVEL_12" : (
                      a === "PRE" ? "PRE" : (
                          a === "LEVEL_0" ? "LEVEL_0" : (
                              a === "LEVEL_1" ? "LEVEL_1" : (
                                  a === "LEVEL_2" ? "LEVEL_2" : (
                                      a === "LEVEL_3" ? "LEVEL_3" : (
                                          a === "LEVEL_4" ? "LEVEL_4" : (
                                              a === "LEVEL_5" ? "LEVEL_5" : (
                                                  a === "LEVEL_6" ? "LEVEL_6" : (
                                                      a === "LEVEL_7" ? "LEVEL_7" : (
                                                          a === "LEVEL_8" ? "LEVEL_8" : (
                                                              a === "LEVEL_9" ? "LEVEL_9" : "UNKNOWN"
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          locale: a$1 === "en_BZ" ? "en_BZ" : (
              a$1 === "en_CA" ? "en_CA" : (
                  a$1 === "en_CB" ? "en_CB" : (
                      a$1 === "en_GB" ? "en_GB" : (
                          a$1 === "en_IE" ? "en_IE" : (
                              a$1 === "en_IN" ? "en_IN" : (
                                  a$1 === "en_JM" ? "en_JM" : (
                                      a$1 === "en_NZ" ? "en_NZ" : (
                                          a$1 === "en_PH" ? "en_PH" : (
                                              a$1 === "en_TT" ? "en_TT" : (
                                                  a$1 === "en_US" ? "en_US" : (
                                                      a$1 === "en_ZA" ? "en_ZA" : (
                                                          a$1 === "en_ZW" ? "en_ZW" : "en_AU"
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          md5: inp.md5
        };
}

function makeVariables$1(id, yearLevel, locale, md5, param) {
  return {
          id: id,
          yearLevel: yearLevel,
          locale: locale,
          md5: md5
        };
}

var MenuQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1
};

var include$1 = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query$1,
      Raw: Raw$1,
      parse: parse$1,
      serialize: serialize$1,
      serializeVariables: serializeVariables$1
    });

var use$1 = include$1.use;

var useFetch$1 = include$1.useFetch;

var MenuQuery = {
  MenuQuery_inner: MenuQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  use: use$1,
  useFetch: useFetch$1
};

var MQ = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw$1,
      use: use$1,
      useFetch: useFetch$1
    });

function makeCategories(nodes) {
  return Belt_Array.map(nodes, (function (n) {
                return {
                        id: n.id,
                        title: n.title,
                        subtitle: n.description,
                        progress: 100,
                        accuracy: "green",
                        hasActivities: n.hasActivities,
                        parentId: n.parentId
                      };
              }));
}

var Raw$2 = {};

var query$2 = GraphqlTag.gql([
      "query AcademyActivitiesQuery($id: ID!, $yearLevel: LearningLevelEnum!, $locale: Locale!, $md5: String!)  {\nfindActivitiesByParentId(id: $id, locale: $locale, md5: $md5)  {\n...ActivityFragment   \n}\n\nfindBreadCrumb(id: $id, locale: $locale, md5: $md5)  {\n...MenuFragment   \n}\n\nfindStrandsByLevel(level: $yearLevel, locale: $locale, md5: $md5)  {\n...MenuFragment   \n}\n\n}\n",
      "",
      ""
    ], AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.query, AcademyFragments$LiteracyplanetClientSxEntry.ActivityFragment.query);

function parse$2(value) {
  var value$1 = value.findActivitiesByParentId;
  var value$2 = value.findBreadCrumb;
  var value$3 = value.findStrandsByLevel;
  return {
          findActivitiesByParentId: value$1.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.ActivityFragment.verifyArgsAndParse("ActivityFragment", value);
              }),
          findBreadCrumb: value$2.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.verifyArgsAndParse("MenuFragment", value);
              }),
          findStrandsByLevel: value$3.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.verifyArgsAndParse("MenuFragment", value);
              })
        };
}

function serialize$2(value) {
  var value$1 = value.findStrandsByLevel;
  var findStrandsByLevel = value$1.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.serialize(value);
      });
  var value$2 = value.findBreadCrumb;
  var findBreadCrumb = value$2.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.MenuFragment.serialize(value);
      });
  var value$3 = value.findActivitiesByParentId;
  var findActivitiesByParentId = value$3.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.ActivityFragment.serialize(value);
      });
  return {
          findActivitiesByParentId: findActivitiesByParentId,
          findBreadCrumb: findBreadCrumb,
          findStrandsByLevel: findStrandsByLevel
        };
}

function serializeVariables$2(inp) {
  var a = inp.yearLevel;
  var a$1 = inp.locale;
  return {
          id: inp.id,
          yearLevel: a === "LEVEL_10" ? "LEVEL_10" : (
              a === "LEVEL_11" ? "LEVEL_11" : (
                  a === "LEVEL_12" ? "LEVEL_12" : (
                      a === "PRE" ? "PRE" : (
                          a === "LEVEL_0" ? "LEVEL_0" : (
                              a === "LEVEL_1" ? "LEVEL_1" : (
                                  a === "LEVEL_2" ? "LEVEL_2" : (
                                      a === "LEVEL_3" ? "LEVEL_3" : (
                                          a === "LEVEL_4" ? "LEVEL_4" : (
                                              a === "LEVEL_5" ? "LEVEL_5" : (
                                                  a === "LEVEL_6" ? "LEVEL_6" : (
                                                      a === "LEVEL_7" ? "LEVEL_7" : (
                                                          a === "LEVEL_8" ? "LEVEL_8" : (
                                                              a === "LEVEL_9" ? "LEVEL_9" : "UNKNOWN"
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          locale: a$1 === "en_BZ" ? "en_BZ" : (
              a$1 === "en_CA" ? "en_CA" : (
                  a$1 === "en_CB" ? "en_CB" : (
                      a$1 === "en_GB" ? "en_GB" : (
                          a$1 === "en_IE" ? "en_IE" : (
                              a$1 === "en_IN" ? "en_IN" : (
                                  a$1 === "en_JM" ? "en_JM" : (
                                      a$1 === "en_NZ" ? "en_NZ" : (
                                          a$1 === "en_PH" ? "en_PH" : (
                                              a$1 === "en_TT" ? "en_TT" : (
                                                  a$1 === "en_US" ? "en_US" : (
                                                      a$1 === "en_ZA" ? "en_ZA" : (
                                                          a$1 === "en_ZW" ? "en_ZW" : "en_AU"
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          md5: inp.md5
        };
}

function makeVariables$2(id, yearLevel, locale, md5, param) {
  return {
          id: id,
          yearLevel: yearLevel,
          locale: locale,
          md5: md5
        };
}

var ActivitiesQuery_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2
};

var include$2 = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query$2,
      Raw: Raw$2,
      parse: parse$2,
      serialize: serialize$2,
      serializeVariables: serializeVariables$2
    });

var use$2 = include$2.use;

var useFetch$2 = include$2.useFetch;

var ActivitiesQuery = {
  ActivitiesQuery_inner: ActivitiesQuery_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  use: use$2,
  useFetch: useFetch$2
};

var AQ = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw$2,
      use: use$2,
      useFetch: useFetch$2
    });

function calcPercent(numerator, denominator) {
  return Math.ceil(numerator / denominator * 100) | 0;
}

function makeActivities(activities) {
  return Belt_Array.map(activities, (function (a) {
                var accuracy = a.result.bestResponsesScore;
                var accuracy$1 = accuracy !== undefined ? accuracy : (
                    a.result.bestScoreNumComplete > 0 ? calcPercent(a.result.bestScoreNumCorrect, a.result.bestScoreNumComplete) : undefined
                  );
                var score = Belt_Option.map(accuracy$1, (function (accuracy) {
                        return {
                                accuracy: accuracy,
                                trophy: Trophy$LiteracyplanetClientSxEntry.scoreToTrophy(accuracy)
                              };
                      }));
                return {
                        id: a.id,
                        academyActivityId: a.result.academyActivityId,
                        menuNodeId: a.menuNodeId,
                        title: a.title,
                        kind: a.result.kind,
                        contentKind: a.result.contentKind,
                        score: score,
                        progressState: a.result.started ? "Started" : (
                            Belt_Option.isSome(accuracy$1) ? "Finished" : "NotStarted"
                          )
                      };
              }));
}

function handleIndexResponse(res) {
  return {
          loading: false,
          levels: [],
          strands: makeCategories(res.findStrandsByLevel),
          breadcrumb: [],
          data: {
            TAG: "Strands",
            _0: {
              categories: makeCategories(res.findStrandsByLevel)
            }
          }
        };
}

function useIndex(locale) {
  var $$fetch = Curry._1(IQ.useAsync, undefined);
  return async function (md5, yearLevel) {
    return await Curry._1($$fetch, {
                yearLevel: yearLevel,
                locale: locale,
                md5: md5
              });
  };
}

function handleMenuResponse(res) {
  return {
          loading: false,
          levels: [],
          strands: makeCategories(res.findStrandsByLevel),
          breadcrumb: makeCategories(res.findBreadCrumb),
          data: {
            TAG: "Categories",
            _0: {
              categories: makeCategories(res.findMenuNodesByParentId)
            }
          }
        };
}

function useMenu(locale) {
  var $$fetch = Curry._1(MQ.useAsync, undefined);
  return async function (md5, id, yearLevel) {
    return await Curry._1($$fetch, {
                id: id,
                yearLevel: yearLevel,
                locale: locale,
                md5: md5
              });
  };
}

function handleActivitiesResponse(res) {
  return {
          loading: false,
          levels: [],
          strands: makeCategories(res.findStrandsByLevel),
          breadcrumb: makeCategories(res.findBreadCrumb),
          data: {
            TAG: "Activities",
            _0: {
              activities: makeActivities(res.findActivitiesByParentId)
            }
          }
        };
}

function useActivities(locale) {
  var $$fetch = Curry._1(AQ.useAsync, undefined);
  return async function (md5, id, yearLevel) {
    return await Curry._1($$fetch, {
                id: id,
                yearLevel: yearLevel,
                locale: locale,
                md5: md5
              });
  };
}

function use$3(md5, yearLevel, category) {
  var api = LocaleContext$LiteracyplanetClientFlags.use();
  var locale = api.locale;
  var match = React.useState(function (param) {
        return {
                loading: true,
                levels: YearLevelMappingQuery$LiteracyplanetClientSxEntry.levels,
                strands: [],
                breadcrumb: [],
                data: "InitialisingAcademy"
              };
      });
  var setData = match[1];
  var fetchIndex = useIndex(locale);
  var fetchMenu = useMenu(locale);
  var fetchActivites = useActivities(locale);
  var ylm = YearLevelMappingQuery$LiteracyplanetClientSxEntry.use();
  React.useEffect((function (param) {
          if (ylm.loading) {
            
          } else {
            Curry._1(setData, (function (d) {
                    return {
                            loading: d.loading,
                            levels: ylm.levels,
                            strands: d.strands,
                            breadcrumb: d.breadcrumb,
                            data: d.data
                          };
                  }));
          }
        }), [ylm]);
  React.useEffect((function (param) {
          Curry._1(setData, (function (d) {
                  return {
                          loading: true,
                          levels: d.levels,
                          strands: d.strands,
                          breadcrumb: d.breadcrumb,
                          data: d.data
                        };
                }));
          var run = async function (f) {
            var data;
            if (category !== undefined) {
              var id = category.id;
              data = category.hasActivities ? Belt_Option.map(await Curry._3(fetchActivites, md5, id, yearLevel), handleActivitiesResponse) : Belt_Option.map(await Curry._3(fetchMenu, md5, id, yearLevel), handleMenuResponse);
            } else {
              data = Belt_Option.map(await Curry._2(fetchIndex, md5, yearLevel), handleIndexResponse);
            }
            return Belt_Option.mapWithDefault(data, undefined, (function (data) {
                          Curry._1(setData, (function (param) {
                                  return {
                                          loading: data.loading,
                                          levels: param.levels,
                                          strands: data.strands,
                                          breadcrumb: data.breadcrumb,
                                          data: data.data
                                        };
                                }));
                        }));
          };
          run();
        }), [
        locale,
        md5,
        yearLevel,
        category
      ]);
  return match[0];
}

var MenuFragment;

var ActivityFragment;

export {
  MenuFragment ,
  ActivityFragment ,
  IndexQuery ,
  IQ ,
  MenuQuery ,
  MQ ,
  makeCategories ,
  ActivitiesQuery ,
  AQ ,
  calcPercent ,
  makeActivities ,
  handleIndexResponse ,
  useIndex ,
  handleMenuResponse ,
  useMenu ,
  handleActivitiesResponse ,
  useActivities ,
  use$3 as use,
}
/* query Not a pure module */
